// extracted by mini-css-extract-plugin
export default {"formGroup":"Input_formGroup__FE7ue","label":"Input_label__BHlNP","input":"Input_input__nz6QJ"};